import AbstractValue from '@/models/app-config/behavior/abstract-value'

export interface RawPromotion {
  freeShipping: {
    show: boolean
  }
  freeShippingItem: RawFreeShippingItem
}

export default class Promotion extends AbstractValue<RawPromotion> {
  get freeShipping(): FreeShipping {
    return new FreeShipping(this.raw.freeShipping)
  }

  /**
   * 送料無料フラグの商品によって注文の送料が無料になることを、カートで表示するか
   */
  get freeShippingItem(): FreeShippingItem {
    return new FreeShippingItem(this.raw.freeShippingItem)
  }
}

export interface RawFreeShipping {
  show: boolean
}

class FreeShipping  extends AbstractValue<RawFreeShipping> {
  get show(): boolean {
    return this.raw.show
  }
}

export interface RawFreeShippingItem {
  show: boolean
}

class FreeShippingItem extends AbstractValue<RawFreeShippingItem> {
  get show(): boolean {
    return this.raw.show
  }
}
